import { authApi, authMiddleware, authSlice, baseApiService } from '@qapline/api';
import { configureStore } from '@reduxjs/toolkit';
import { appSlice } from 'core/application';
import { carrierApi } from 'modules/carriers/services';
import { commissionsApi } from 'modules/commissions/services';
import { commissionSlice } from 'modules/commissions/store';
import { customersApi } from 'modules/customers/services';
import { enquiryApi, offerSlice } from 'modules/offers/services';
import { dispatchersApi } from 'modules/onboarding/services';

const slices = {
    [authSlice.name]: authSlice.reducer,
    [appSlice.name]: appSlice.reducer,
    [offerSlice.name]: offerSlice.reducer,
    [commissionSlice.name]: commissionSlice.reducer,
};

const apis = {
    [baseApiService.reducerPath]: baseApiService.reducer,
    [carrierApi.reducerPath]: carrierApi.reducer,
    [customersApi.reducerPath]: customersApi.reducer,
    [dispatchersApi.reducerPath]: dispatchersApi.reducer,
    [enquiryApi.reducerPath]: enquiryApi.reducer,
};

const middleware = [
    baseApiService.middleware,
    carrierApi.middleware,
    customersApi.middleware,
    commissionsApi.middleware,
    dispatchersApi.middleware,
    enquiryApi.middleware,
];

// Register reducers here from individual modules
export const store = configureStore({
    reducer: {
        ...slices,
        ...apis,
    },
    devTools: true,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            // according to the redux-toolkit maintainer, we need to turn off serializableCheck
            // to be able to pass File as mutation argument (used in InvoiceBasicForm).
            // source: https://github.com/reduxjs/redux-toolkit/issues/1239#issuecomment-875708062
            serializableCheck: false,
            ignoredPath: [
                authApi.reducerPath,
                carrierApi.reducerPath,
                customersApi.reducerPath,
                commissionsApi.reducerPath,
                enquiryApi.reducerPath,
            ],
        })
            .prepend(authMiddleware.middleware)
            .concat(...middleware),
});
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
